// extracted by mini-css-extract-plugin
export default {"button":"ExerciseTopicsHeader_button__lICpV"};